import { ChevronDown, FolderOpen, Sparkles } from "lucide-react";
import { useState } from "react";
import { useUI } from "../../stores/ui";

const GREETINGS = {
  morning: "Buenos días",
  afternoon: "Buenas tardes",
  evening: "Buenas noches",
} as const;

function greetingFor(hour: number): string {
  if (hour < 12) return GREETINGS.morning;
  if (hour < 20) return GREETINGS.afternoon;
  return GREETINGS.evening;
}

export function HomeHero({ name = "Manuel" }: { name?: string }) {
  const scope = useUI((s) => s.scope);
  const setChatDraft = useUI((s) => s.setChatDraft);
  const setChatPanel = useUI((s) => s.setChatPanel);
  const [q, setQ] = useState("");

  function submit() {
    const trimmed = q.trim();
    if (!trimmed) return;
    // D5 (2026-05-25): ask-bar abre el ChatRail in-place (sin cambiar de ruta).
    setChatDraft(trimmed);
    setChatPanel("open");
    setQ("");
  }

  const scopeLabel = scope === "doc" ? "doc actual" : scope === "all" ? "todo" : "colección";

  return (
    <section className="home-hero" data-testid="home-hero">
      <div className="home-greeting text-xs uppercase tracking-wider text-(--text-tertiary) mb-2">
        {greetingFor(new Date().getHours())}, {name}
      </div>
      <h1 className="text-3xl font-semibold leading-tight mb-6">
        Retoma donde lo dejaste, o{" "}
        <span className="text-(--accent-600)">pregunta lo que necesites</span>.
      </h1>

      <form
        className="ask-bar"
        data-testid="ask-bar"
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
      >
        <button type="button" className="ask-bar-scope" data-testid="ask-bar-scope">
          <FolderOpen size={12} />
          <span>{scopeLabel}</span>
          <ChevronDown size={11} />
        </button>
        <input
          data-testid="ask-bar-input"
          placeholder="Pregunta sobre cualquier doc, runbook o apunte…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          aria-label="Pregunta a DocuStudio"
        />
        <button
          type="submit"
          className="ask-bar-send"
          data-testid="ask-bar-send"
          disabled={!q.trim()}
          aria-label="Preguntar"
        >
          <Sparkles size={12} /> Preguntar
        </button>
      </form>
    </section>
  );
}
